export enum ADDRESS_SLIP_TRANSLATION_KEYS {
    ADDRESS_SLIP_FOR_RMA = 'ADDRESS_SLIP_FOR_RMA',
    ADDRESS_SLIP_ORDER_ID = 'ADDRESS_SLIP_ORDER_ID',
    ADDRESS_SLIP_ORDER_ID_BARCODE = 'ADDRESS_SLIP_ORDER_ID_BARCODE',
    ADDRESS_SLIP_WAREHOUSE_RMA_ID = 'ADDRESS_SLIP_WAREHOUSE_RMA_ID',
    ADDRESS_SLIP_WAREHOUSE_RMA_ID_BARCODE = 'ADDRESS_SLIP_WAREHOUSE_RMA_ID_BARCODE',
    ADDRESS_SLIP_SHIP_TO = 'ADDRESS_SLIP_SHIP_TO',
    ADDRESS_SLIP_SENT_BY = 'ADDRESS_SLIP_SENT_BY',
    ADDRESS_SLIP_INSTRUCTIONS = 'ADDRESS_SLIP_INSTRUCTIONS',
}